import React, {Component} from 'react';
import ModifyInstitutionScheduleView from "./ModifyInstitutionScheduleView";
import {Growl} from "primereact/growl";
import {MaintenanceScheduleService} from "../../../../service/maintenance/schedule/MaintenanceScheduleService";
import {CatalogService} from "../../../../service/catalog/CatalogService";

export default class ModifyInstitutionScheduleContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceScheduleService = new MaintenanceScheduleService();
        this.catalogService = new CatalogService();
        this.getInstitutions = this.getInstitutions.bind(this);
        this.setDataInstitution = this.setDataInstitution.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            dataInstitution: this.setDataInstitution(),
            newInstitution: this.props.location.state.newInstitution,
            pageTitle: this.props.location.state.newInstitution ?
                "Agregar" : "Editar",
            activeCheck: this.props.location.state.dataInstitution.activo === 1,
            institutions: this.getInstitutions(),
            isLoading: true,
        };

        this.onChangeSelectBox = this.onChangeSelectBox.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.returnMaintenancePage = this.returnMaintenancePage.bind(this);
        this.saveInstitutionSchedule = this.saveInstitutionSchedule.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que inicializa los datos de la institución
     * ya sea para ser editada o para agregar un nuevo horario.
     * @returns {*} Objeto inicializado
     */
    setDataInstitution() {
        let dataInstitutionsAux = this.props.location.state.dataInstitution ?
            this.props.location.state.dataInstitution : {};

        if (this.props.location.state.newInstitution) {
            let dateAux = new Date();
            dateAux.setHours(0);
            dateAux.setMinutes(0);
            dateAux.setSeconds(0);
            dataInstitutionsAux['horaFinal'] = dateAux;
            dataInstitutionsAux['activo'] = 0;
        } else {
            let timeArray = (dataInstitutionsAux['horaFinal']).split(":");
            let dateAux = new Date();
            dateAux.setHours(timeArray[0]);
            dateAux.setMinutes(timeArray[1]);
            dateAux.setSeconds(0);
            dataInstitutionsAux['horaFinal'] = dateAux;
        }
        return dataInstitutionsAux;
    }

    /**
     * Función que consume a CatalogService y obtiene el catálogo de
     * instituciones, lo coloca en una variable del state y también
     * coloca el objeto que trae el elemento a editar.
     */
    getInstitutions() {
        this.loading();
        let dataInstitutionAux = this.props.location.state.dataInstitution;
        this.catalogService.getInstitutionCatalog()
            .then(dataInstitutions => this.setState({
                institutions: dataInstitutions,
                institutionObject: this.props.location.state.newInstitution ? null :
                    dataInstitutions.find((item) =>
                        item['idInstitucion'] === dataInstitutionAux['idInstitucion']),
                isLoading: false,
            }));
    }

    /**
     * Función que maneja el cambio de valor que se realice en el select
     * box que se muestra en la vista y coloca el valor en el state
     * dentro del objeto a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeSelectBox(event) {
        let dataAux = this.state.dataInstitution;
        event.checked ?
            dataAux['activo'] = '1' :
            dataAux['activo'] = '0';
        this.setState({
            activeCheck: event.checked,
            dataInstitution: dataAux,
        });
    }

    /**
     * Función que maneja el cambio de valor en el campo de hora.
     * @param name Nombre del elemento modificado en la vista.
     * @param date Valor del elemento modificado en la vista.
     */
    handleTimeChange(name, date) {
        let dataAux = this.state.dataInstitution;
        dataAux[name] = date;
        this.setState({
            dataInstitution: dataAux,
        })
    }

    /**
     * Función que regresa a la pantalla de
     * Mantenimiento de horarios.
     */
    returnMaintenancePage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            activeIndex: 1,
            message: message,
        });
    }

    /**
     * Función  que maneja el cambio de valor en el dropdown
     * Debido a que el campo dropdown, maneja un objeto. Hace esa conversión para
     * colocar el valor en el objeto a editar.
     * @param event Valor asignado en la vista.
     */
    handleChangeValue(event) {
        const {value} = event.target;
        let dataInstitutionAux = this.state.dataInstitution;

        dataInstitutionAux['idInstitucion'] = value['idInstitucion'];
        this.setState({
            institutionObject: value,
            dataInstitution: dataInstitutionAux,
        });
    }

    /**
     * Función que consume a MaintenanceAccountsService para guardar los datos
     * del elemento a editar.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    saveInstitutionSchedule() {
        let dataInstitutionAux = this.state.dataInstitution;

        if (dataInstitutionAux.idInstitucion) {
            let dateAux = '';
            if (!dataInstitutionAux['horaFinal']) {
                dateAux = new Date();
                dateAux.setHours(0);
                dateAux.setMinutes(0);
                dateAux.setSeconds(0);
            } else {
                dateAux = dataInstitutionAux['horaFinal'];
            }
            dataInstitutionAux['horaFinalStr'] = dateAux.getHours() + ":" + dateAux.getMinutes();
            dataInstitutionAux['activo'] = dataInstitutionAux['activo'] ? dataInstitutionAux['activo'] : 0;

            this.loading();

            this.maintenanceScheduleService.updateInstitutionSchedule(dataInstitutionAux)
                .then(resp => {
                    let messageObj = {};
                    let message = resp.message;
                    let error = resp.error;
                    if (message === 'Success') {
                        messageObj['severity'] = 'success';
                        messageObj['sumary'] = 'Éxito';
                        messageObj['detail'] = this.state.newInstitution ?
                            'El registro se ha insertado exitosamente.' :
                            'El registro se ha modificado exitosamente.';
                        this.returnMaintenancePage(messageObj);
                    } else if (error !== "") {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: error});
                    }
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos correctamente.'});
        }
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            activeCheck, isLoading, pageTitle, institutions, institutionObject,
            dataInstitution
        } = this.state

        return (
            <ModifyInstitutionScheduleView
                messagesGrowl={messagesGrowl}
                activeCheck={activeCheck}
                isLoading={isLoading}
                pageTitle={pageTitle}
                institutions={institutions}
                institutionObject={institutionObject}
                dataInstitution={dataInstitution}
                onChangeSelectBox={this.onChangeSelectBox}
                handleChangeValue={this.handleChangeValue}
                handleTimeChange={this.handleTimeChange}
                saveInstitutionSchedule={this.saveInstitutionSchedule}
                returnMaintenancePage={this.returnMaintenancePage}
            />
        );
    }
}
